// src/styles/theme.js
// Tema centralizado, 100% alineado con la guía de estilo de Spanish Fluency School

const theme = {
  colors: {
    // Colores Primarios (Azul SFS)
    primary: '#115173', // Azul principal de la guía
    primaryLight: '#3A7A9E', // Tono intermedio para hover/gradientes
    primaryDark: '#0B3E59', // Tono más oscuro para estados activos

    // Colores Secundarios (Naranja SFS)
    secondary: '#FA9F25', // Naranja principal de la guía
    secondaryLight: '#FBC02D',
    secondaryDark: '#F57F17',

    // Colores de Acento y Fondo (Crema SFS)
    accent: '#FA9F25', // El naranja funciona como acento principal
    background: {
      white: '#FFFFFF',
      light: '#F5F0E8', // Crema SFS de la guía
      neutral: '#F8F9FA', // Un gris muy claro para complementar
      dark: '#102A43', // Un azul muy oscuro para fondos de sección
    },

    // Colores neutrales (para compatibilidad con componentes existentes)
    neutral: {
      100: '#F8F9FA', // Gris muy claro
      200: '#E8EDF2', // Gris claro con tinte azul
      300: '#D1DBE5', // Gris medio-claro
      400: '#829AB1', // Gris medio (mismo que text.light)
      500: '#486581', // Gris medio-oscuro (mismo que text.secondary)
    },

    // Colores de texto
    text: {
      primary: '#102A43', // Casi negro, pero con un toque azulado
      secondary: '#486581',
      light: '#829AB1',
      white: '#FFFFFF',
    },

    // Colores de estado
    success: '#27AE60',
    warning: '#F39C12',
    error: '#E74C3C',
    info: '#3498DB',
  },

  // Tipografía (Según la guía de estilo)
  fonts: {
    heading: '"Lora", serif',
    body: '"Lato", sans-serif',
  },

  fontWeights: {
    regular: 400,
    medium: 500,
    bold: 700,
    extrabold: 900,
  },

  fontSizes: {
    xs: '0.75rem',    // 12px
    sm: '0.875rem',   // 14px
    base: '1rem',     // 16px
    lg: '1.125rem',   // 18px
    xl: '1.25rem',    // 20px
    '2xl': '1.5rem',  // 24px
    '3xl': '1.875rem', // 30px
    '4xl': '2.25rem', // 36px
    '5xl': '3rem',    // 48px
  },

  // Espaciado y Radios consistentes
  spacing: {
    xs: '0.25rem',   // 4px
    sm: '0.5rem',    // 8px
    md: '1rem',      // 16px
    lg: '1.5rem',    // 24px
    xl: '2rem',      // 32px
    '2xl': '3rem',   // 48px
    '3xl': '4rem',   // 64px
  },

  borderRadius: {
    sm: '0.25rem',
    md: '0.5rem',
    lg: '0.75rem',
    xl: '1rem',
    '2xl': '1.5rem',
    full: '9999px',
  },

  // Sombras más suaves y modernas
  shadows: {
    sm: '0 2px 8px 0 rgba(16, 42, 67, 0.07)',
    md: '0 4px 12px -1px rgba(16, 42, 67, 0.1), 0 2px 8px -1px rgba(16, 42, 67, 0.06)',
    lg: '0 10px 20px -3px rgba(16, 42, 67, 0.1), 0 4px 8px -2px rgba(16, 42, 67, 0.05)',
    xl: '0 20px 30px -5px rgba(16, 42, 67, 0.12), 0 10px 15px -5px rgba(16, 42, 67, 0.04)',
  },

  breakpoints: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
  },

  transitions: {
    fast: '150ms ease-in-out',
    base: '250ms ease-in-out',
    slow: '350ms ease-in-out',
  },
};

export default theme;
